import React, {useEffect, useRef, useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles} from "@material-ui/core";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import Loading from "components/Loading";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import Select from "components/Select";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    loading: {
        width: '98%'
    },
    buttonRow: {
        textAlign: "end"
    },
    uploadFile: {
        marginBottom: 20
    }
}));

function AddNewOpinionMemberPopup(
    {
        groupId,
        onClose,
        apiPathType,
        formSubmit,
    }) {

    const classes = useStyle();

    const sendType = useRef('');
    const [working, setWorking] = useState(true);
    const [contractorList, setContractorList] = useState([]);
    const formId = useId();


    const handleSubmit = (type) => {
        sendType.current = type;
        formSubmit[formId]();
    }

    useEffect(() => {
        PurchasingGroupStage1Service.getOpinionAvailableMembers(groupId, apiPathType).then((resp) => {
            if(resp) {
                setContractorList(resp.map(x => ({label: x.name, value: x.identity})));
                setWorking(false)
            } else {
                onClose()
            }

        });
        // eslint-disable-next-line
    }, [groupId, apiPathType]);


    const onSubmit = (opinion) => {
        setWorking(true);
        const send = sendType.current === 'send';
        sendType.current = "";

        PurchasingGroupStage1Service.addOpinionForMember(groupId, apiPathType, opinion.memberId).then((newOpinion) => {
            if (newOpinion) {
                PurchasingGroupStage1Service.saveOpinionMessage(groupId, apiPathType, newOpinion.identity, {
                    identity: 0,
                    contents: opinion.contents,
                    send: send
                }).then(() => onClose(newOpinion.identity))
            } else {
                onClose();
            }
        }).catch(() => setWorking(false));
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working));
        buttons.push(createButton(Tr('save'), () => handleSubmit('save'), 'outlined', working));
        buttons.push(createButton(Tr('send'), () => handleSubmit('send'), undefined, working));
        return buttons;
    }


    return (
        <Dialog
            title={Tr("purchasing_group_add_new_opinion")}
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()}/>}
        >
            <Form
                initialValues={{
                    memberId: null,
                    contents: ""
                }}
                validationSchema={Yup.object().shape({
                    memberId: VS.anyRequired(),
                    contents: VS.string(),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        {working && <Loading className={classes.loading}/>}

                        <Select
                            id="memberId"
                            formikProps={formikProps}
                            label={Tr('choose_recipients')}
                            disabled={working}
                            items={contractorList}
                            required
                        />


                        <TextInput
                            id='contents'
                            formikProps={formikProps}
                            label={Tr('contents')}
                            disabled={working}
                            multiline
                            required
                        />

                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddNewOpinionMemberPopup);